import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const eventSessionsApi = createApi({
    reducerPath: "eventSessionsApi",
    tagTypes: ["eventSessions"],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: (build) => ({
        getEventSessions: build.query({
            query: (data) => ({
                url: api.eventSessions.getEventSessions(data.settingable_id),
                method: "GET",
                params: data,
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            providesTags: ["eventSessions"],
        }),
        createEventSession: build.mutation({
            query: (data) => ({
                url: api.eventSessions.createEventSession(),
                method: 'POST',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled

                    dispatch(
                        eventSessionsApi.util.updateQueryData('getEventSessions', patch, (draft) => {
                            draft.unshift(data)
                        })
                    )
                } catch (error) {
                    console.error('Failed to update cache:', error)
                }
            },
        }),
        updateEventSession: build.mutation({
            query: ({id, ...data}) => ({
                url: api.eventSessions.updateEventSession(id),
                method: 'PUT',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        eventSessionsApi.util.updateQueryData('getEventSessions',  {location_id: patch.location_id} , (draft) => {
                            const itemIndex = draft?.findIndex(item => item.id === patch.id)
                            if (itemIndex !== -1) {
                                draft[itemIndex] = data
                            }
                        })
                    )
                } catch(e) {
                    console.error('Update failed:', e)
                }
            },
        }),
        deleteEventSession: build.mutation({
            query: ({ id }) => ({
                url: api.eventSessions.deleteEventSession(id),
                method: 'DELETE',
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(
                        eventSessionsApi.util.updateQueryData('getEventSessions', patch, (draft) => {
                            const index = draft.findIndex((session) => session.id === patch.id);
                            if (index !== -1) {
                                draft.splice(index, 1)
                            } else {
                                console.warn('Session not found in cache')
                            }
                        })
                    );
                } catch (e) {
                    console.error('Delete failed:', e)
                }
            },
        }),
        getSessionUsers: build.query({
            query: ({id, ...data}) => ({
                url: api.eventSessions.getSessionUsers(id),
                method: 'GET',
                params: data,
            }),
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                return [endpointName, queryArgs?.location_id, queryArgs?.storage_id]
            },
            merge: (currentCache, newItems, {arg}) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({currentArg, previousArg}) => {
                return currentArg !== previousArg;
            },
        }),
    }),
});

export const { useDeleteEventSessionMutation, useLazyGetSessionUsersQuery } = eventSessionsApi;
